module.exports = __webpack_public_path__ + "rexiao.png?ba3e02c7778c3d15f0540fc7de4f5c55";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rexiao.png
// module id = 49
// module chunks = 0